export const types = {
    NORMALIZEMESAURE: 'NORMALIZE-MESAURE',
    SORTARRAY:'SORT-ARRAY',
    FILTERROWSCELL:'FILTER-ROWS-CELLS',
    SPLITCOLUMN:'SPLIT-COLUMN',
    FILLEMPTY:'FILL-EMPTY-CELLS'
};